import { Dictionary } from "@dreamcam/babylon-tools";
export class NewFeatureBlinkHelper {
    constructor() {
        this._interval = null;
        this._intervalStepIndex = 0;
        this._newFeatureDots = new Dictionary();
        this._intervalHandler = () => {
            this._setMarkVisibility(this._intervalStepIndex >= NewFeatureBlinkHelper._intervalOffStepIndex);
            this._intervalStepIndex = (++this._intervalStepIndex) % NewFeatureBlinkHelper._intervalStepsCount;
        };
    }
    start() {
        if (this._interval !== null)
            return;
        this._interval = setInterval(this._intervalHandler, NewFeatureBlinkHelper._intervalPeriodMillis);
        // Log.debug("%cNewFeatureBlinkHelper.start()", "background: yellow");
    }
    stop() {
        if (this._interval !== null) {
            // Log.debug("%cNewFeatureBlinkHelper.stop()", "background: yellow");
            clearInterval(this._interval);
            this._interval = null;
            // this._newFeatureDots.clear();
        }
    }
    addNewFeatureDot(controlName, control) {
        if (!this._newFeatureDots.hasKey(controlName)) {
            // Log.debug(`%cAdding dot control ${controlName}`, "background: yellow");
            this._newFeatureDots.add(controlName, control);
        }
    }
    removeNewFeatureDot(controlName) {
        if (this._newFeatureDots.hasKey(controlName)) {
            // Log.debug(`%Removing dot control ${controlName}`, "background: yellow");
            this._newFeatureDots.remove(controlName);
        }
    }
    _setMarkVisibility(isVisible) {
        for (let key of this._newFeatureDots.keys) {
            const dot = this._newFeatureDots.getValue(key);
            if (dot)
                dot.isVisible = isVisible;
        }
        // Log.debug(`%cisVisible: ${isVisible}`, "background: lime");
    }
}
NewFeatureBlinkHelper._intervalPeriodMillis = 250;
NewFeatureBlinkHelper._intervalStepsCount = 4;
NewFeatureBlinkHelper._intervalOffStepIndex = 2;
